import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { Observable } from "rxjs";

import { Coordinates } from "@hermes/api-model-common";

import { MapEvent, MarkerData } from "./map.type";

@Directive()
export abstract class AbstractMapComponent {
    /**
     * Observable that describes the events that should be listened by the map component
     */
    @Input()
    public mapEvent$!: Observable<MapEvent>;

    /**
     * List of markers to be displayed
     */
    @Input()
    public markers!: MarkerData[];

    /**
     *
     */
    @Input()
    public displayZoom = false;

    /**
     * Activate or not the functionality of marker clusterer
     */
    @Input()
    public isMarkerClustererActive = false;

    /**
     * Activate or not the zoom on click feature
     */
    @Input()
    public isZoomOnClickActive = true;

    /**
     * Deal with feature on mobile mode only
     */
    @Input()
    public isInMobile = false;

    /**
     * Display the button the pass into fullscreen mode
     */
    @Input()
    public hasFullScreenButton = true;

    /**
     * Send to its parent the markers in map bounds
     */
    @Output()
    public markersCoordinatesInBounds = new EventEmitter<MarkerData[]>();

    /*
     * Send to its parent the marker coordinates which is selected
     */
    @Output()
    public hoveredMarkerCoordinates: EventEmitter<Coordinates> =
        new EventEmitter<Coordinates>();

    /*
     * Send to its parent the marker coordinates which is unselected
     */
    @Output()
    public unhoveredMarkerCoordinates: EventEmitter<Coordinates> =
        new EventEmitter<Coordinates>();

    /**
     * Send to its parent that map is fully initialized
     */
    @Output()
    public mapInitialized = new EventEmitter<boolean>(false);

    /**
     * Send to its parent the marker coordinates which is clicked
     */
    @Output()
    public clickedMarkerCoordinates: EventEmitter<Coordinates> =
        new EventEmitter<Coordinates>();
}
